import setupTooltips from '../shared/enquiry-tooltips';

export default {
  loaded() {
    setupTooltips()
  }
}
